import * as moment from 'moment'

export class AdministrationListModel {
  id: number
  name: string
  trade_name: string
  created_at: any
  stopped_at: any
  owner: string
  owner_id: number
  legal_form: string

  constructor(administration) {
    this.id = administration.id
    this.name = administration.name
    this.owner = administration.owner_name
    this.owner_id = administration.owner_id
    this.trade_name = administration.trade_name
    this.legal_form = administration.legal_form
    this.created_at = moment(administration.created_at)

    if (administration.stopped_at !== null) {
      this.stopped_at = moment(administration.stopped_at)
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/administration.list.model.ts